import React, { useEffect, useState } from 'react';
import './SearchingContent.css'; // Custom animation styles

const messages = [
  "Looking for nearby drivers",
  "Searching in your area",
  "Finding the best match",
  "Hang tight, almost done"
];

const SearchingContent = ({ isAccepted }) => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (isAccepted) return;

    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, 10000); // Change every 10 seconds

    return () => clearInterval(interval);
  }, [isAccepted]);

  return (
    <div className="searching-wrapper">

        <div className="searching-content animate-liquid-slide">
          <div className="searching-text">{messages[messageIndex]}</div>
          <div className="liquid-dots">
            <span className="liquid-dot" />
            <span className="liquid-dot" />
            <span className="liquid-dot" />
          </div>
        </div>
    </div>
  );
};

export default SearchingContent;
